import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69c09482"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex"]
const _hoisted_2 = { class: "relative w-10 h-9" }
const _hoisted_3 = { class: "timeline-row grow" }
const _hoisted_4 = { class: "relative w-10 shrink-0" }
const _hoisted_5 = {
  key: 0,
  class: "absolute top-0 left-1/2 h-full border-l-solid border-l-white border-l-.5px"
}
const _hoisted_6 = { class: "rounded-lg p-4 mt-1 mb-4 text-sm font-sans tracking-wide bg-poppy flex-grow" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-right"
}
const _hoisted_10 = ["tabindex"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "mt-2 text-right"
}
const _hoisted_13 = ["tabindex"]

import { onUpdated, reactive, ref } from 'vue'
import { TimelineItem } from './types'
import CaretDown from '@/assets/svg/CaretDown.vue'
import useLanguage from '@/composables/useLanguage'
import type { Ref } from 'vue'

interface Props {
  data: TimelineItem
  index: number
  isActive: boolean
  isFirst: boolean
  isLast: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineRow',
  props: {
    data: null,
    index: null,
    isActive: { type: Boolean },
    isFirst: { type: Boolean },
    isLast: { type: Boolean }
  },
  emits: ["toggleRowExpanded", "toggleContentExpanded"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggleRowExpanded', index: number): void
  (e: 'toggleContentExpanded', index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: TimelineItem
  index: number
  isActive: boolean
  isFirst: boolean
  isLast: boolean
}




const timelineText = useLanguage('timeline')
const interfaceText = useLanguage('interface')
const element: Ref<HTMLElement | null> = ref(null)
let lastActive = false
const state = reactive({
  isExpanded: false,
})

const handleToggleRowExpanded = (evt) => {
  emit('toggleRowExpanded', props.index)
  evt.stopPropagation()
}

const focusShowMoreLink = () => {
  const link = element.value?.querySelector('.show-more-link') as HTMLElement
  if (link) link.focus()
}

const focusShowLessLink = () => {
  const link = element.value?.querySelector('.show-less-link') as HTMLElement
  if (link) link.focus()
}

const handleToggleContentExpanded = (evt) => {
  state.isExpanded = !state.isExpanded
  emit('toggleContentExpanded', props.index)
  evt.stopPropagation()
  if (state.isExpanded) {
    setTimeout(focusShowLessLink, 100)
  } else {
    setTimeout(focusShowMoreLink, 100)
  }
}

onUpdated(() => {
  if (props.isActive && !lastActive) {
    focusShowMoreLink()
    lastActive = props.isActive
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: "pr-5"
  }, [
    _createElementVNode("button", {
      class: "flex w-full text-left cursor-pointer leading-9",
      tabindex: (props.index + 1) * 10,
      onClick: handleToggleRowExpanded
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "relative w-10px h-10px rounded-full bg-white",
          style: _normalizeStyle({
            left: 'calc(50% - 5px)',
            top: 'calc(50% - 5px)',
          })
        }, null, 4),
        _createElementVNode("div", {
          class: _normalizeClass(["absolute left-1/2 border-l-solid border-l-white border-l-.5px", 
            props.isFirst
              ? 'top-1/2 h-9'
              : props.isLast
              ? 'top-0 h-1/2'
              : 'top-0 h-full'
          ])
        }, null, 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["text-white grow flex items-center", 
          !props.isFirst ? 'border-t-solid border-t-white border-t-.5px' : null
        ])
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(`${props.data.year}: ${_unref(timelineText)[props.data.id].title}`), 1),
        _createVNode(CaretDown, {
          class: _normalizeClass(["transition-transform", props.isActive ? 'rotate-180' : null])
        }, null, 8, ["class"])
      ], 2)
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["timeline-row flex mr-5 overflow-hidden cursor-pointer", props.isActive ? 'max-h-[1000px]' : 'max-h-0'])
    }, [
      _createElementVNode("div", _hoisted_4, [
        (!props.isLast)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (props.data.popover.thumbnail)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "mb-2 rounded-lg w-full max-h-200px object-cover object-center",
              "data-test": "timeline-thumbnail",
              src: `/images/mjp/${props.data.popover.thumbnail}`,
              alt: props.data.popover.thumbnailAlt
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true),
        (props.isActive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["timeline-row-wrapper overflow-hidden", !state.isExpanded ? 'max-h-[150px]' : 'max-h-0'])
            }, [
              _createElementVNode("p", {
                class: "timeline-row-content",
                "data-test": "timeline-text",
                innerHTML: _unref(timelineText)[props.data.id].text
              }, null, 8, _hoisted_8),
              (props.data.popover.action && !state.isExpanded)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "show-more-link underline underline-offset-2 font-sans font-medium",
                      href: "#",
                      tabindex: (props.index + 1) * 10 + 1,
                      onClick: handleToggleContentExpanded
                    }, _toDisplayString(_unref(interfaceText).showMore), 9, _hoisted_10)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (props.isActive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["timeline-row-wrapper overflow-hidden", state.isExpanded ? 'max-h-[700px]' : 'max-h-0'])
            }, [
              _createElementVNode("p", {
                class: "timeline-row-content",
                "data-test": "timeline-text",
                innerHTML: _unref(timelineText)[props.data.id].expanded
              }, null, 8, _hoisted_11),
              (props.data.popover.action && state.isExpanded)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                    _createElementVNode("a", {
                      class: "show-less-link underline underline-offset-2 font-sans font-medium",
                      href: "#",
                      tabindex: (props.index + 1) * 10 + 1,
                      onClick: handleToggleContentExpanded
                    }, _toDisplayString(_unref(interfaceText).showLess), 9, _hoisted_13)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 512))
}
}

})